import { render, staticRenderFns } from "./PageParametersCreate.vue?vue&type=template&id=f6b5a12a"
import script from "./PageParametersCreate.vue?vue&type=script&lang=js"
export * from "./PageParametersCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6b5a12a')) {
      api.createRecord('f6b5a12a', component.options)
    } else {
      api.reload('f6b5a12a', component.options)
    }
    module.hot.accept("./PageParametersCreate.vue?vue&type=template&id=f6b5a12a", function () {
      api.rerender('f6b5a12a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pageParameters/PageParametersCreate.vue"
export default component.exports